<div class="header-bar">
  <h1>Reasons for Job Unassignment</h1>
</div>
<div class="">
  <div class="content-container">
    <p-table
      [value]="jobUnassignedReasons"
      [(selection)]="selectedReason"
      [rows]="5"
      selectionMode="single"
      paginator="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Code</th>
          <th>Reason</th>
          <th>Blame</th>
          <th>Weight</th>
          <th>Active</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr (dblclick)="editReason()" (click)="reasonChosen(data)" [pSelectableRow]="data">
          <td>
            <span class="code" style="">
              {{ data.code }}
            </span>
          </td>
          <td>
            <span class="description" style="">
              {{ data.description }}
            </span>
          </td>
          <td>
            <span class="blame" style="">
              {{ blameName[data.blame] }}
            </span>
          </td>
          <td style="text-align: center">
            <span class="weight">
              {{ data.weight }}
            </span>
          </td>
          <td style="text-align: center">
            <span *ngIf="data.isActive"><i class="fa fa-check text-success"></i></span>
            <span *ngIf="!data.isActive"><i class="fa fa-times text-error"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED ---
    <p-dataTabl [value]="jobUnassignedReasons" [(selection)]="selectedReason" [rows]="5" selectionMode="single"
                 (onRowDblclick)="editReason()"
                 paginator="true"
                 (onRowClick)="reasonChosen($event)">
      <p-column field="code" header="Code" [sortable]="true">
        <ng-template let-data="rowData" pTemplate="body">
          <span class="code" style="">
          {{ data.code }}
        </span>
        </ng-template>
      </p-column>
      <p-column field="description" header="Reason" [sortable]="true">
        <ng-template let-data="rowData" pTemplate="body">
          <span class="description" style="">
          {{ data.description }}
        </span>
        </ng-template>
      </p-column>
      <p-column field="blame" header="Blame" [sortable]="true">
        <ng-template let-data="rowData" pTemplate="body">
          <span class="blame" style="">
          {{ blameName[data.blame] }}
        </span>
        </ng-template>
      </p-column>
      <p-column field="weight" header="Weight" [sortable]="true">
        <ng-template let-data="rowData" pTemplate="body">
          <span class="weight" style="">
          {{ data.weight }}
        </span>
        </ng-template>
      </p-column>
      <p-column field="isActive" header="Active" [sortable]="true" [style]="{'width':'100px','text-align':'center'}">
        <ng-template let-data="rowData" pTemplate="body">
          <span *ngIf="data.isActive"><i class="fa fa-check text-success"></i></span>
          <span *ngIf="!data.isActive"><i class="fa fa-times text-error"></i></span>
        </ng-template>
      </p-column>
    </p-dataTable>
    --->

    <div class="text-right mt-2">
      <button pButton label="Delete" (click)="deleteReason()" *ngIf="selectedReason"></button>
      <button pButton label="Edit" (click)="editReason()" *ngIf="selectedReason"></button>
      <button pButton label="Add Reason" (click)="addReason()"></button>
    </div>
  </div>
</div>

<p-dialog
  header="Unassigned Reason"
  [(visible)]="showEditReason"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <form [formGroup]="reasonForm">
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="code">Code</label>
      </div>

      <div class="ui-g-8">
        <input
          pInputText
          name="code"
          maxlength="4"
          style="width: 100%"
          formControlName="code"
          autocomplete="off"
          id="code"
        />
      </div>

      <div class="ui-g-4">
        <label for="description">Description</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          name="description"
          style="width: 100%"
          formControlName="description"
          autocomplete="off"
          id="description"
        />
      </div>

      <div class="ui-g-4">
        <label for="description">Blame</label>
      </div>
      <div class="ui-g-8">
        <p-selectButton [options]="blameButtons" formControlName="blame"></p-selectButton>
      </div>

      <div class="ui-g-4">
        <label for="weight">Weight</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          name="weight"
          minVal="0"
          maxVal="100"
          type="number"
          maxlength="3"
          style="width: 100%"
          formControlName="weight"
          autocomplete="off"
          id="weight"
        />
      </div>

      <div class="ui-g-4">
        <label for="isActive">Active</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
      </div>

      <div class="ui-g-4">&nbsp;</div>
      <div class="ui-g-8">
        <button
          (click)="saveReason()"
          pButton
          [label]="saving ? 'Wait..' : 'Save'"
          [disabled]="saving || !reasonForm.valid"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
